import React from "react";

const uploading = () => {
  return <div>Congrats! File uploaded successfully to IPFS</div>;
};

export default uploading;
